import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./assets/styles/themes/default.css"
import { LoadingOverlay, MantineProvider } from "@mantine/core";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "styled-components";
import { ThemeProvider as CustomThemeProvider } from './context/theme-context'
import "react-toastify/dist/ReactToastify.css";
import { App } from "./App";
import { AppProviders } from "./context";
import reportWebVitals from "./reportWebVitals";
import { lightTheme, mantineThemeOverrides } from "./themes";

import "./i18next/config";

const container = document.getElementById("root");
if (!container) throw new Error("container not found!");

const root = createRoot(container);
root.render(
	<React.StrictMode>
		<AppProviders>
			<MantineProvider theme={mantineThemeOverrides}>
        <CustomThemeProvider>
        <ThemeProvider theme={lightTheme}>
					<Suspense fallback={<LoadingOverlay visible />}>
						<App />
					</Suspense>
					<ToastContainer
						autoClose={4000}
						hideProgressBar
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss={false}
						draggable
						pauseOnHover={false}
					/>
				</ThemeProvider>
        </CustomThemeProvider>
			
			</MantineProvider>
		</AppProviders>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
